module.exports = __webpack_public_path__ + "img/randolph-county-logo.958f691a.jpg";